import { Link } from "react-router-dom";
import { Wrench, Zap, Flame, Wind, Snowflake, KeyRound, Hammer, Drill, Sparkles, ArrowRight, Check } from "lucide-react";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal, Overline } from "../components/Reveal";
import { GoldButton } from "../components/GoldButton";
import { METIERS, ARTISAN_FORMULES } from "../data/content";

const ICONS = {
  plomberie: Drill, electricite: Zap, chauffage: Flame, ventilation: Wind,
  climatisation: Snowflake, serrurerie: KeyRound, menuiserie: Hammer,
  "petits-travaux": Wrench, entretien: Sparkles,
};

export default function Metiers() {
  const available = METIERS.filter((m) => m.available);
  return (
    <div data-testid="metiers-page">
      <Seo title="Nos métiers & corps d'état" path="/metiers"
        description="Les domaines d'intervention Speed Détresse : plomberie, électricité, chauffage, ventilation, serrurerie, menuiserie et entretien." />
      <PageHero
        overline="Domaines d'intervention"
        title={["Nos métiers &", "corps d'état"]}
        subtitle="Les domaines couverts par nos techniciens. La disponibilité exacte dépend de votre secteur et est confirmée lors de la qualification de la demande."
        testid="metiers-hero"
      />

      <section className="relative z-10 mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {available.map((m, i) => {
            const Icon = ICONS[m.id] || Wrench;
            return (
              <Reveal key={m.id} delay={(i % 3) * 0.06}>
                <div data-testid={`metier-${m.id}`} className="h-full rounded-2xl border border-white/10 bg-navy-surface/60 p-7 transition-colors hover:border-gold/40">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 text-gold">
                    <Icon className="h-5 w-5" strokeWidth={1.5} />
                  </div>
                  <h3 className="mt-5 font-serif text-2xl text-white">{m.label}</h3>
                  <p className="mt-2 text-sm text-slate-400">{m.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-xs text-gold">
                    <Check className="h-3.5 w-3.5" /> Disponible selon secteur
                  </span>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="mt-14">
          <div className="rounded-2xl border border-white/10 bg-navy p-6 text-sm text-slate-400">
            <span className="font-semibold text-gold">Ouverture prochaine :</span> la liste définitive des corps d'état et des zones réellement couvertes sera confirmée à l'ouverture de l'application. Aucun service n'est promis avant cette validation.
          </div>
        </Reveal>

        {/* Offres artisans */}
        <div className="mt-20" data-testid="artisan-formules">
          <Reveal><Overline>Artisans & techniciens</Overline></Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-5 font-serif text-4xl tracking-tight text-white md:text-5xl">Des outils conçus pour votre activité</h2>
            <p className="mt-4 max-w-2xl text-slate-400">
              Plusieurs niveaux d'accès sont prévus. Les prix seront publiés uniquement après validation commerciale.
            </p>
          </Reveal>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
            {ARTISAN_FORMULES.map((f, i) => (
              <Reveal key={f.name} delay={i * 0.05}>
                <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-navy-surface/60 p-6">
                  <h3 className="font-serif text-xl text-gold">{f.name}</h3>
                  <p className="mt-3 flex-1 text-sm text-slate-400">{f.desc}</p>
                  <span className="mt-4 text-xs uppercase tracking-wide text-slate-500">Tarif à venir</span>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="mt-6 text-sm text-slate-500">
              Gains potentiels estimés par notre modèle (objectifs, sans garantie contractuelle) : jusqu'à −30 % de temps de préparation, −40 % de temps administratif, −60 % sur la création d'un devis.
            </p>
          </Reveal>
        </div>

        <Reveal className="mt-12 flex flex-wrap gap-4">
          <GoldButton to="/souscription" size="lg">Demander une prestation <ArrowRight className="h-4 w-4" /></GoldButton>
          <GoldButton to="/solutions" size="lg" variant="outline">Voir les prestations</GoldButton>
        </Reveal>
      </section>
    </div>
  );
}
